import { type FC } from "react";
import { Check } from "lucide-react";

import { cn } from "@/shared/utils/core";

interface WizardStepperProps {
  currentStep: 1 | 2 | 3;
}

const STEPS = [
  { number: 1, label: "Client information" },
  { number: 2, label: "Choose plan" },
  { number: 3, label: "Review" },
] as const;

export const WizardStepper: FC<WizardStepperProps> = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center gap-3 sm:gap-6">
      {STEPS.map((step, index) => {
        const isCompleted = step.number < currentStep;
        const isActive = step.number === currentStep;

        return (
          <div key={step.number} className="flex items-center gap-3 sm:gap-6">
            <div className="flex items-center gap-2">
              <div
                className={cn(
                  "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-sm font-medium leading-none",
                  isCompleted && "bg-brand text-white",
                  isActive && "bg-brand text-white",
                  !isCompleted && !isActive && "border border-primary bg-white text-tertiary",
                )}
              >
                {isCompleted ? <Check className="h-4 w-4" /> : step.number}
              </div>
              <span
                className={cn(
                  "hidden text-sm font-medium sm:inline",
                  isActive ? "text-primary" : "text-tertiary",
                )}
              >
                {step.label}
              </span>
            </div>
            {index < STEPS.length - 1 && <div className="h-px w-8 bg-stone-200 sm:w-16" />}
          </div>
        );
      })}
    </div>
  );
};
